'use client';

import { EVENT_NAMES } from '@/utils/track';
import { Button, Paragraph } from '@swordhealth/ui-corporate';
import { ButtonContainer, FieldPair, Form, ErrorMessage, ImageWrapper } from './styles';
import { formFields } from './form-fields';
import { identify, trackEvent } from '@/lib/segment';
import { useFormik } from 'formik';
import { useState } from 'react';
import { validationSchema } from './validation-schema';
import CircleAlert from '@swordhealth/ui-corporate/icons/system/circle-alert-1px.svg';
import Field from '@/components/core/Field';

const staticCopy = {
  label:
    'By submitting this form, I acknowledge that I have read and accept Swords' +
    ' <a href="https://swordhealth.com/legal/privacy-statement" target="_blank" rel="noreferrer">Privacy Policy</a>',
  error:
    'There was a problem submitting the form. Please check the information entered and try again. If the problem persists, contact technical support.',
};

const PersonalDetailsForm = ({ buttonLabel, initialValues, name, setFormData, setStep }) => {
  const [error, setError] = useState(false);

  const formik = useFormik({
    initialValues: initialValues || {
      name: name || '',
      bestDay: '',
      bestTime: '',
      phoneNumber: undefined,
    },
    validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, actions) => {
      actions.setSubmitting(true);

      try {
        await identify(null, {
          ...values,
        });

        trackEvent(EVENT_NAMES.FORM_SUBMIT, {
          step_name: 'personal_details',
        });

        setFormData(values);

        setStep(1);
      } catch (e) {
        setError(true);
      }

      actions.setSubmitting(false);
    },
  });

  return (
    <>
      <Form onSubmit={formik.handleSubmit} noValidate>
        {Object.keys(formFields).map(function (key) {
          const field = formFields[key];
          if (Array.isArray(field)) {
            return (
              <FieldPair key={`fieldpair_${key}`}>
                {field.map((pairField) => (
                  <Field
                    {...pairField}
                    formik={formik}
                    id={`personal-details-form-${pairField.name}`}
                    key={pairField.name}
                  />
                ))}
              </FieldPair>
            );
          }

          return (
            <Field
              {...field}
              formik={formik}
              id={`personal-details-form-${field.name}`}
              key={field.name}
            />
          );
        })}

        <Paragraph>{staticCopy.label}</Paragraph>

        {error && (
          <ErrorMessage>
            <ImageWrapper>
              <CircleAlert />
            </ImageWrapper>

            <Paragraph>{staticCopy.error}</Paragraph>
          </ErrorMessage>
        )}

        <ButtonContainer>
          <Button
            disabled={formik.isSubmitting}
            id="next-button"
            loading={formik.isSubmitting}
            type="submit"
          >
            {buttonLabel ?? 'Submit'}
          </Button>
        </ButtonContainer>
      </Form>
    </>
  );
};

export default PersonalDetailsForm;
